import Button from '../Button';
import { Field, Input, Label, Select } from '../Field';
import { addDays, format, parse } from 'date-fns';
import RadioGroup from '../RadioGroup';
import { useState, useEffect } from 'react';
import { fetchSlots } from '../../providers/slots';

function Fields({ clinic, coupon, fields, submitting, setFieldValue, t }) {
    const [slots, setSlots] = useState([]);
    const [hasVideo, setHasVideo] = useState(false);
    const [otherPatient, setOtherPatient] = useState(false);
    const [specialties, setSpecialties] = useState([]);
    const [price, setPrice] = useState(0);
    const [total, setTotal] = useState(0);

    useEffect(() => {
        const specialty = clinic.specialties.find(({ id }) => id == fields.specialty_id);
        const _price = specialty?.price || 0;
        const _total = _price - (coupon || 0);

        setHasVideo(specialty?.video == true);
        setPrice(_price);
        setTotal(_total);
    }, [fields.specialty_id]);

    useEffect(() => {
        if (!otherPatient) {
            setFieldValue('name', '');
        }
    }, [otherPatient]);

    useEffect(() => {
        if (!hasVideo) {
            setFieldValue('video', false);
        }
    }, [hasVideo]);

    useEffect(() => {
        if (fields.time) {
            if (!slots.find(({ start }) => fields.time == format(new Date(start), 'HH:mm'))) {
                setFieldValue('time', '');
            }
        }
    }, [slots]);

    useEffect(() => {
        const { professional_id, date } = fields;
        if (professional_id && date) {
            const fromDate = parse(`${date} 00:00`, 'yyyy-MM-dd HH:mm', new Date());
            const from = fromDate.toISOString();
            const to = addDays(fromDate, 1).toISOString();
            fetchSlots({ professional_id, from, to }).then(setSlots);
        } else {
            setSlots([]);
        }
    }, [fields.professional_id, fields.date]);

    useEffect(() => {
        if (clinic && fields.professional_id) {
            const professional = clinic.professionals.find(({ id }) => id == fields.professional_id);
            setSpecialties(professional?.specialties);
        } else {
            setSpecialties([]);
        }
    }, [clinic, fields.professional_id]);

    const changeHandler = (e) => {
        const { name, value } = e.target;
        setFieldValue(name, value);
    };

    const isValid = () => fields.specialty_id && fields.professional_id && fields.date && fields.time && (!otherPatient || fields.name.trim());

    return (
        <div className="space-y-4">
            <div className="space-y-2">
                <Field>
                    <Label>{t('professional')}</Label>
                    <Select name="professional_id" options={clinic.professionals} value={fields.professional_id} onChange={changeHandler} />
                </Field>

                <Field>
                    <Label>{t('specialty')}</Label>
                    <Select name="specialty_id" options={specialties} value={fields.specialty_id} onChange={changeHandler} disabled={!fields.professional_id} />
                </Field>

                {fields.specialty_id && (
                    <Field>
                        <Label>{t('format.label')}</Label>
                        <RadioGroup
                            value={fields.video}
                            onChange={(value) => {
                                setFieldValue('video', value);
                            }}
                            options={[
                                {
                                    value: false,
                                    label: t('format.in-person'),
                                },
                                {
                                    value: true,
                                    label: t('format.video'),
                                    disabled: !hasVideo,
                                },
                            ]}
                        ></RadioGroup>
                    </Field>
                )}

                <Field>
                    <Label>
                        <span>{t('date')}</span>
                        <Input type="date" name="date" value={fields.date} onChange={changeHandler} />
                    </Label>
                </Field>

                <Field>
                    <Label>
                        <span>{t('time')}</span>
                    </Label>
                    <input type="hidden" name="time" value={fields.time} readOnly />
                    <div className="flex flex-wrap gap-2">
                        {slots.length ? (
                            slots.map(({ start, isAvailable }) => {
                                const time = format(new Date(start), 'HH:mm');
                                const active = time == fields.time;
                                return (
                                    <button
                                        key={time}
                                        type="button"
                                        disabled={!isAvailable}
                                        className={`${
                                            active ? 'cursor-default border-blue-400 bg-blue-100 text-blue-700' : 'border-blue-100 bg-blue-50 text-blue-600'
                                        } rounded border px-3 py-2 disabled:border-gray-200 disabled:bg-gray-100 disabled:text-gray-400`}
                                        onClick={() => {
                                            setFieldValue('time', time);
                                        }}
                                    >
                                        {time}
                                    </button>
                                );
                            })
                        ) : (
                            <span className="px-3 py-2 text-gray-400 bg-gray-100 border border-gray-200 rounded">{t('no-slots')}</span>
                        )}
                    </div>
                </Field>

                <Field>
                    <Label>{t('recipient.label')}</Label>
                    <RadioGroup
                        value={otherPatient}
                        onChange={setOtherPatient}
                        options={[
                            {
                                value: false,
                                label: t('recipient.myself'),
                            },
                            {
                                value: true,
                                label: t('recipient.someone-else'),
                            },
                        ]}
                    ></RadioGroup>
                </Field>

                {otherPatient && (
                    <Field>
                        <Label>
                            <span>{t('recipient.patient-name')}</span>
                            <Input
                                type="text"
                                name="name"
                                value={fields.name}
                                onChange={(event) => {
                                    setFieldValue('name', event.target.value);
                                }}
                            />
                        </Label>
                    </Field>
                )}
            </div>

            {fields.specialty_id && (
                <div className="py-4">
                    <h3 className="pb-2 text-xl font-medium text-blue-600 border-b-2 border-blue-600">{t('total')}</h3>
                    <div className="flex justify-between py-2">
                        <div className="text-5xl font-semibold">{total.toFixed(2)}€</div>
                        {/* <div>
                            <table>
                                <tbody>
                                    <tr>
                                        <td>{t('price')}</td>
                                        <td className="pl-12 text-right">{price}&euro;</td>
                                    </tr>
                                    <tr>
                                        <td>{t('discount')}</td>
                                        <td className="pl-12 text-right">{coupon ? `${coupon.toFixed(2)}€` : '--'}</td>
                                    </tr>
                                    {clinic.coupon && (
                                        <>
                                            <tr className="text-blue-700">
                                                <td>{t('saving')}</td>
                                                <td className="pl-12 text-right">{clinic.coupon}€</td>
                                            </tr>
                                            <tr>
                                                <td colSpan="2" className="text-sm text-gray-400">
                                                    ({t('for-next-appointment')})
                                                </td>
                                            </tr>
                                        </>
                                    )}
                                </tbody>
                            </table>
                        </div> */}
                    </div>
                </div>
            )}

            <div className="flex justify-end">
                <Button type="submit" disabled={!isValid()} className="min-w-[120px]">
                    {submitting ? (
                        <svg className="w-5 h-5 text-white animate-spin" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                        </svg>
                    ) : (
                        t('action-active')
                    )}
                </Button>
            </div>
        </div>
    );
}

export default Fields;
